import axios from "axios";
import { BASE_URL } from "../../variables";
import { sessionExpireTimeout } from "@redux/actions/utility-actions";

export const deleteSaveAsDraftForMVRApi = (draftId) => async (dispatch) => {
  const options = {
    url: `${BASE_URL}/services/apexrest/DeleteSaveAsDraftForMVR/${draftId}`,
    method: "delete"
  };

  try {
    const response = await axios(options);
    if (response.status === 200 || (response?.results?.length > 0 && response?.hasErrors === false)) {
      return {
        success: true,
        data: response?.data,
      };
    } else {
      throw Error("Something Went Wrong..!!");
    }
  } catch (err) {
    if (err?.response?.status === 401) {
      sessionExpireTimeout(dispatch);
    } else {
      return {
        success: false,
        msg: "Somthing Went Wrong..!!",
      };
    }
  }
};
